import React, { forwardRef } from 'react'
import { SvgIcon, SvgIconProps } from '@mui/material'

const SuccessAlert = forwardRef<SVGSVGElement, SvgIconProps>(
  function SuccessAlert(props, ref) {
    return (
      <SvgIcon ref={ref} {...props}>
        <path d="m1.965256,18.990615l6.451,0l3.583612,4.909372l3.583612,-4.909372l6.450994,0c0.321486,0 0.56863,-0.24922 0.56863,-0.573404l-0.000963,-17.86878c0,-0.324183 -0.247145,-0.573404 -0.56863,-0.573404l-20.067986,0c-0.321486,0 -0.56863,0.24922 -0.56863,0.573404l0.000963,17.86878c0,0.324183 0.247151,0.573404 0.567673,0.573404l-0.000275,0zm7.179593,-11.227923l1.693923,1.713314l4.040967,-4.063487l1.742126,1.786931l-4.040967,4.063487l-1.766715,1.762067l-1.742126,-1.786931l-1.693923,-1.713314l1.766715,-1.762067z" />
      </SvgIcon>
    )
  },
)

export default SuccessAlert
